import type { FestivalState } from "@/lib/festival-weather/types";

const TONES: Record<FestivalState, string> = {
  live_forecast: "bg-emerald-100 text-emerald-800 border-emerald-200",
  climate: "bg-sky-100 text-sky-800 border-sky-200",
  recently_finished: "bg-amber-100 text-amber-900 border-amber-200",
  awaiting_snapshot: "bg-slate-100 text-slate-700 border-slate-200",
  awaiting_archive: "bg-slate-100 text-slate-700 border-slate-200",
};

type Props = {
  state: FestivalState;
  happeningNow?: boolean;
  year?: number;
};

function getLabel(state: FestivalState, happeningNow?: boolean, year?: number): string {
  switch (state) {
    case "live_forecast":
      return happeningNow ? "Happening now" : "Live forecast";
    case "climate":
      return "Coming up";
    case "recently_finished":
      return year ? `Done for ${year}` : "Done";
    case "awaiting_snapshot":
    case "awaiting_archive":
      return "Processing";
  }
}

export function StateTag({ state, happeningNow, year }: Props) {
  const tone = TONES[state];
  const label = getLabel(state, happeningNow, year);
  const showPulse = state === "live_forecast";
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-[1.2px] border ${tone}`}
    >
      {showPulse && (
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" aria-hidden />
      )}
      {label}
    </span>
  );
}
